/**
 * Whether an event target is a text-entry control whose own keyboard handling
 * must not be hijacked by a global shortcut (typing, caret movement, native
 * select navigation). Shared by every window-level key handler.
 */
export function inTextField(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  return (
    tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable === true
  );
}
